module.exports = __webpack_public_path__ + "img/max_deposit_ntd_mobile.6dd1c63f.png";